import React from 'react';
import Contenido from './Contenido';
import Header from './Header';

const Page = (props) => {
    return (
        <>
            <Header></Header>
            <Contenido datos={props.datos.titulo}>
                {props.children}
            </Contenido>
        </>
    );
}

export default Page;